import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import AuthLayout from "@/components/AuthLayout";
import { useAuth } from "@/lib/AuthContext";

export default function DownloadApp() {
  const { t } = useTranslation();
  const { isAuthenticated, logout } = useAuth();
  return (
    <AuthLayout icon={Smartphone} title={t("webGate.title")} subtitle={t("webGate.subtitle")}>
      <div data-testid="download-app-page" className="space-y-4 text-center">
        <p className="text-foreground">{t("webGate.body")}</p>
        <p className="text-sm text-muted-foreground" data-testid="download-app-stores">{t("webGate.stores")}</p>
        {isAuthenticated && (
          <Button variant="outline" className="w-full h-12" data-testid="download-app-logout" onClick={() => logout()}>
            {t("webGate.logout")}
          </Button>
        )}
      </div>
    </AuthLayout>
  );
}
